import { Box, Card, CardHeader, CardContent, Typography } from '@mui/material';
import React from 'react';

import { Logo } from '../../components-core/landing/Logo';

export const TransactionAlreadyPaid = () => (
  <Card sx={{ height: '100%' }}>
    <Logo />
    <Box display="flex" justifyContent="center" flexDirection="column" alignItems="center">
      <CardHeader title="Transakcja opłacona" sx={{ mt: 5 }} />
      <CardContent>
        <Typography>Ta transakcja została już opłacona</Typography>
        <p>&nbsp;</p>
        <p>Możesz teraz zamknąć tę stronę lub wrócić na stronę: <a href="https://zapisy.jujutsupoland.com/">https://zapisy.jujutsupoland.com</a> </p>
        <p>W przypadku pytań lub wątpliwości prosimy o kontakt mailowy lub telefoniczny: <b>+48 502 080 348</b> lub <b>zapisy@jujutsupoland.com</b></p>
      </CardContent>
    </Box>
  </Card>
);
